<input type="input" (keyup)="Search($event)" class="form-control">

<div *ngIf="results.length===0 && searchTerm!==''">No results </div>
<div class="card result-set" *ngIf="results.length > 0">
  <ul class="result-list">
    <li *ngFor="let item of results" (click)="SelectAddress(item)" class="result" data-value="item.id"><span
        [innerText]="item.place_name"></span></li>
  </ul>
  <div class="search-attribution" [innerText]="attribution"></div>
</div>
